import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChatSidebar from 'components/chat/ChatSidebar';
import { HistoryTable } from 'components/organisms/HistoryTable';
import { ClassificationResultItem } from 'types/document.types';
import { HistoryProvider } from 'context/HistoryContext';
import useSidebarStore from 'stores/sidebarStore';

const ResultsInner: React.FC = () => {
  const navigate = useNavigate();
  const { isCollapsed } = useSidebarStore();

  const handleRowClick = (item: ClassificationResultItem) => {
    if (item.conversation_id) {
      navigate('/chat', { state: { conversationId: item.conversation_id } });
    }
  };

  const handleNewClassification = () => {
    navigate('/');
  };

  return (
    <div className="h-screen gradient-bg">
      <div className="gradient-content h-full">
        <ChatSidebar onNewClassification={handleNewClassification} />
        <main className={`${isCollapsed ? 'ml-[72px]' : 'ml-64'} h-screen overflow-hidden flex flex-col transition-all duration-200`}>
          <div className="flex-1 overflow-auto">
            <div className="max-w-[1600px] mx-auto p-6">
              <div className="mb-6">
                <h1 className="text-3xl font-bold text-gray-900">Classification Results</h1>
                <p className="text-gray-600 mt-2">
                  Your HTS classification history at a glance
                </p>
              </div>
              <HistoryTable onRowClick={handleRowClick} />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const Results: React.FC = () => {
  return (
    <HistoryProvider>
      <ResultsInner />
    </HistoryProvider>
  );
};

export default Results;
